import React from "react";
import { Link } from "react-router-dom";

export default function Section3() {
  return (
    <div className="w-full Section2">
      <div className="container-1280 section2-container w-[100%] md:w-[100%] xl:w-[100%] pt-5 mx-auto flex flex-col md:flex-row">
        <div className="image-container w-full px-[15px] md:w-[70%] sxl:w-[50%] h-auto md:h-[100%] m-auto">
          <img
            className="block object-contain w-auto h-full mx-auto md:w-full rounded-lg"
            src="../../../../assets/IMG_0052-min-1-1-scaled.jpg"
            alt="CEO Image"
          ></img>
        </div>
        <div className="w-full text-left px-[15px] md:w-[50%]">
          <h2 className=" text-[18px] font-bold mt-5 mb-2 md:mt-0 md:mb-2">Collaboration</h2>
          <p className="pb-5 text-[14px] leading-normal font-open text-[#000] font-normal">
           The backbone of all our processes. It takes more than an individual to plan, design, and execute great ideas - it takes a dedicated team. Mean3 cultivates collaboration-focused culture for best results.
          </p>
          <h2 className=" text-[18px] font-bold mb-5 md:mb-2">Commendation</h2>
          <p className="pb-5 text-[14px] leading-normal font-open text-[#000] font-normal">
           Together we flourish, together we grow. Mean3 seizes every opportunity to celebrate its employees’ achievements, growth, and contributions.
          </p>
          <h2 className=" text-[18px] font-bold mb-5 md:mb-2">Career expansion</h2>
          <p className="pb-5 text-[14px] leading-normal font-open text-[#000] font-normal">
           Learn, develop, and thrive! Mean3 turns a monotonous routine into a career expansion opportunity by offering dynamic experiences.
          </p>
          <h2 className=" text-[18px] font-bold mb-5 md:mb-2">Co-existing</h2>
          <p className="pb-5 text-[14px] leading-normal font-open text-[#000] font-normal">
           Inclusivity is everything. Mean3 work culture is diverse, inclusive, and respectable to every individual defying normative boundaries. Everyone is treated equally and encouraged to co-exist peacefully.
          </p>
        </div>
      </div>
      <div className="container-1280 section2-container w-[90%] md:w-[100%] xl:w-[100%] py-5 mx-auto">
        <p className="text-[14px] text-center">We value energetic individuals who are client enthusiasts, eager to learn, and willing to take initiative. If you share the prospect of being surrounded by ambitious, smart, and motivated individuals - find available vacancies</p>
      </div>
    </div>
  );
}
